import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@mui/material/TextField";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { cookieService } from "_services";
import clsx from "clsx";
import Typography from "@mui/material/Typography";
import { useForm } from "react-hook-form";
import IconButton from "@material-ui/core/IconButton";
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useHistory } from "react-router-dom";
import { userActions, mobileActions } from "_actions";
import { withRouter, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PRGLogo from "_assets/images/Logo/PRG-Logo.svg";
import { Zoom, Box, Paper } from "@material-ui/core";

// === Style refresh (visual only, no functionality changes) ===
const useStyles = makeStyles((theme) => ({
  // Page backdrop polish
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: `radial-gradient(1200px 600px at 85% 10%, ${
      theme.palette.GrayPrg?.main || "#4d4d4d"
    } 0%, transparent 60%), linear-gradient(180deg, #1c1c1c, ${theme.palette.DarkGrayPrg?.main || "#2b2b2b"})`,
    padding: theme.spacing(4, 2),
  },

  root: {
    position: "relative",
    margin: "0 auto",
    left: "-30vw",
    width: "100%",
    maxWidth: 440,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(6, 4, 4),
    backdropFilter: "blur(1px)",
    background: `linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))`,
    boxShadow: `0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.08)`,
    border: "1px solid rgba(255,255,255,0.08)",

    "& .MuiFormLabel-root": {
      color: `${theme.palette.WhitePrg.main} !important`,
      zIndex: 1,
    },
    "& .MuiInputBase-root": {
      backgroundColor: `rgba(92,92,92,0.55) !important`,
      borderRadius: 10,
      transition: "box-shadow .2s ease, background-color .2s ease",
    },
    "& .MuiInputBase-root.Mui-focused": {
      boxShadow: `0 0 0 3px ${theme.palette.GreenPrg.main}33`,
      backgroundColor: `rgba(92,92,92,0.75) !important`,
    },
    "& .MuiInputBase-input": {
      color: `${theme.palette.WhitePrg.main} !important`,
      padding: theme.spacing(1.25, 1.5),
      borderRadius: 10,
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(5, 3, 3),
      left: "-25vw",
    },
    [theme.breakpoints.down("sm")]: {
      left: "unset",
    },
  },

  // Forms
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  formMobile: {
    width: "100%",
    marginTop: theme.spacing(2),
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(1.5),
    fontWeight: 600,
    letterSpacing: 0.2,
    textTransform: "none",
    borderRadius: 12,
    backgroundColor: `${theme.palette.GreenPrg.main} !important`,
    boxShadow: `0 8px 18px ${theme.palette.GreenPrg.main}40`,
    transition: "transform .08s ease, box-shadow .2s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: `0 10px 22px ${theme.palette.GreenPrg.main}55`,
      backgroundColor: `${theme.palette.GreenPrg.main} !important`,
      color: theme.palette.DarkGrayPrg.main,
    },
    "&:disabled": {
      opacity: 0.7,
    },
  },

  inputs: {
    backgroundColor: `rgba(92,92,92,0.55) !important`,
    color: `${theme.palette.WhitePrg.main} !important`,
    borderRadius: 10,
  },
  margin: { marginTop: theme.spacing(1) },
  textField: { width: "100%" },

  // Logo ring polish
  imgWrap: {
    position: "relative",
    width: 202,
    height: 202,
    marginTop: -100,
    marginBottom: theme.spacing(3),
    background: "#3b3b3b",
    borderRadius: "50%",
    boxShadow: `inset 0 0 0 1px rgba(255,255,255,0.07), 0 10px 25px rgba(0,0,0,0.45)`,
  },
  imgInnerWrap: {
    position: "absolute",
    top: "50%",
    left: 0,
    right: 0,
    transform: "translateY(-50%)",
    margin: "auto",
    width: 166,
    height: 166,
    backgroundColor: theme.palette.WhitePrg.main,
    borderRadius: "50%",
    borderBottom: `solid 2px ${theme.palette.GreenPrg.main}`,
    boxShadow: `0 0 0px 8px ${theme.palette.GrayPrg.main}`,
  },
  img: {
    position: "absolute",
    top: "50%",
    left: -6,
    right: 0,
    margin: "auto",
    transform: "translateY(-50%)",
    width: 178,
  },

  // Small text / link
  forgotPass: {
    cursor: "pointer",
    textAlign: "right",
    color: theme.palette.WhitePrg.main,
    opacity: 0.9,
    transition: "opacity .15s ease",
    "&:hover": { opacity: 0.6, textDecoration: "underline" },
  },

  // Hero image panel
  landingBox: {
    [theme.breakpoints.down("xl")]: { width: "55vw" },
    [theme.breakpoints.down("lg")]: { width: "50vw" },
    [theme.breakpoints.down("md")]: { width: "45vw", right: 50 },
    [theme.breakpoints.down("sm")]: { display: "none" },
    height: "80vh",
    position: "absolute",
    right: 150,
    top: "10vh",
    borderRadius: "0.5rem",
    overflow: "hidden",
    background: "transparent",
  },
}));

function Login() {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { register, watch } = useForm();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const { loggedIn, loggingIn } = useSelector((state) => state?.auth);
  const mobileLogin = useSelector((state) => state?.mobile?.loggedIn);
  const loginRedirectPath = useSelector((state) => state?.auth?.role?.loginRedirectPath);

  let validation = () => {
    let dataErrors = {};
    if (username.length < 1) dataErrors = { ...dataErrors, username: "Invalid username" };
    if (password.length < 1) dataErrors = { ...dataErrors, password: "Invalid password" };
    if (Object.keys(dataErrors).length > 0) {
      setErrors(dataErrors);
      return false;
    }
    return true;
  };

  let handleSubmit = (e) => {
    e.preventDefault();
    if (!validation()) return;
    setErrors({});
    setShowPassword(false);
    dispatch(userActions.login({ username, password }));
  };

  let handelForgotPass = () => {
    history.push(`/forgot-password`);
  };

  useEffect(() => {
    // Reset loggingIn state when login page mounts
    dispatch(userActions.clearLoggingIn());
  }, [dispatch]);

  // Mobile Claim Login
  const watchLogin = watch("userEmail");
  const handleLogin = (e) => {
    e.preventDefault();
    if (watchLogin) dispatch(mobileActions.login(watchLogin.trim()));
  };

  const url = window.location.href;
  useEffect(() => {
    if (window.location.href.indexOf("mobile-claim/") > -1) return;
    if (window.location.href.indexOf("mobile-claim") > -1) {
      window.location.href = `${url}/`;
      return;
    }
  }, [url]);

  useEffect(() => {
    if (mobileLogin) {
      history.push("/mobile-claim/my-list");
    }
  }, [mobileLogin]);

  const [imgIndex, setImgIndex] = useState(1);
  useEffect(() => {
    const interval = setInterval(() => {
      setImgIndex((prev) => (prev === 13 ? 1 : prev + 1));
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box className={classes.page}>
      <Container component="main" maxWidth="xs">
        {loggedIn && cookieService.get("token") && (
          <Redirect to={loginRedirectPath ? loginRedirectPath : "dashboard"} />
        )}
        <CssBaseline />

        <Box className={classes.landingBox}>
          {Array.from({ length: 13 }).map((_, i) => (
            <Zoom
              in={i + 1 === imgIndex}
              style={{ position: "absolute", boxShadow: "0 18px 45px rgba(0,0,0,0.45)" }}
              key={i}
              timeout={{ appear: 300, enter: 1200, exit: 500 }}
            >
              {
                <img
                  src={`https://storage.googleapis.com/opd-public/landing-images/${i + 1}.jpg`}
                  style={{ objectFit: "cover", width: "100%", height: "100%", borderRadius: "0.5rem" }}
                  alt="Promotional"
                />
              }
            </Zoom>
          ))}
        </Box>

        {window.location.href.indexOf("mobile-claim/") > -1 ? (
          <div className={classes.root}>
            <div className={classes.imgWrap}>
              <div className={classes.imgInnerWrap}>
                <img src={PRGLogo} className={classes.img} alt="Project Resources Group logo" />
              </div>
              <Typography
                variant="subtitle1"
                component="div"
                gutterBottom
                style={{ position: "relative", top: 230, marginBottom: 20, textAlign: "center" }}
              >
                Mobile Claim Login
              </Typography>
            </div>
            <form className={classes.formMobile} noValidate onSubmit={(e) => handleLogin(e)}>
              <TextField
                variant="outlined"
                className={classes.inputs}
                margin="normal"
                fullWidth
                name="userEmail"
                label={`Enter Email`}
                inputRef={register}
                autoComplete="userEmail"
              />
              <Button type="submit" size="large" variant="outlined" fullWidth className={classes.submit}>
                Log In
              </Button>
            </form>
          </div>
        ) : (
          <div className={classes.root}>
            <div className={classes.imgWrap}>
              <div className={classes.imgInnerWrap}>
                <img src={PRGLogo} className={classes.img} alt="Project Resources Group logo" />
              </div>
            </div>
            <form className={classes.form} noValidate onSubmit={(e) => handleSubmit(e)}>
              <TextField
                variant="outlined"
                className={classes.inputs}
                margin="normal"
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                onBlur={(e) => setUsername(e.target.value)}
                helperText={errors["username"] && errors["username"]}
                error={Boolean(errors["username"])}
              />

              <TextField
                type={showPassword ? "text" : "password"}
                variant="outlined"
                className={classes.inputs}
                margin="normal"
                fullWidth
                id="password"
                label="Password"
                name="password"
                autoComplete="password"
                onChange={(e) => setPassword(e.target.value)}
                helperText={errors["password"] && errors["password"]}
                error={Boolean(errors["password"])}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                      >
                        {showPassword ? (
                          <Visibility style={{ color: "var(--WhitePrg)" }} />
                        ) : (
                          <VisibilityOff style={{ color: "var(--WhitePrg)" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={loggingIn}
              >
                {loggingIn ? "Signing In..." : "Sign In"}
              </Button>
              <p onClick={() => handelForgotPass()} className={classes.forgotPass}>
                Forgot Your Password?
              </p>
            </form>
          </div>
        )}
      </Container>
    </Box>
  );
}

const connectedLoginPage = withRouter(Login);
export { connectedLoginPage as Login };
